import $ from 'jquery';

$( function() {
	// make prev/next buttons same height as the slider
	$( '.slider-wrap' ).on( 'init', function() {
		// give firefox more time to calculate the correct slider height before applying it to the buttons.
		// this solves http://jira-id-ks.pt-dlr.de/browse/NEURON-167
		const timeout = navigator.userAgent.toLowerCase().includes( 'firefox' ) ? 2000 : 0;
		setTimeout( () => {
			$( this ).find( '.slick-prev,.slick-next' ).height( $( this ).height() );
		}, timeout );
	} );
	// even on resize
	$( window ).resize( function() {
		clearTimeout( window.resizedFinished );
		window.resizedFinished = setTimeout( function() {
			$( '.slider-wrap' ).each( function() {
				$( this ).find( '.slick-prev,.slick-next' ).height( 0 );
				$( this ).find( '.slick-prev,.slick-next' ).height( $( this ).height() );
			} );
		}, 250 );
	} );

	// and give surrounding columns a special class so we can decrease margins
	$( '.wp-block-column:has(> .wp-block-prj-pt-gutenberg-blocks-slider)' ).addClass( 'column-with-slider' );
} );

require( 'Blocks/slider/frontend.js' );
